import {
    GETROLEDROPLISTFORDEALER_SUCCESS,
    GETROLEDROPLISTFORDEALER_FAILED,
    RESET_GETROLEDROPLISTFORDEALER,
    LOADING_GETROLEDROPLISTFORDEALER,
    NETWORK_ERROR_GETROLEDROPLISTFORDEALER,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETROLEDROPLISTFORDEALER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case GETROLEDROPLISTFORDEALER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case GETROLEDROPLISTFORDEALER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_GETROLEDROPLISTFORDEALER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_GETROLEDROPLISTFORDEALER:
            return (state = initialState);
        default:
            return state;
    }
};